export default "__VITE_ASSET__Bk83$S2T__"